import React from "react";

export default function LockedContactInfo({
  isPremium,
  phoneNumber,
  userName = "User",
  onUnlockClick,
  variant = "default", // 'default' | 'card' | 'inline'
}) {
  if (!isPremium || !phoneNumber) {
    if (variant === "inline") {
      return (
        <button
          onClick={onUnlockClick}
          className="inline-flex items-center gap-2 text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 font-semibold text-sm transition"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
          Unlock Contact
        </button>
      );
    }

    if (variant === "card") {
      return (
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 border-2 border-dashed border-amber-300 dark:border-amber-700 rounded-lg p-4 text-center">
          <div className="text-3xl mb-2">🔒</div>
          <h3 className="font-bold text-gray-800 dark:text-white mb-1">Contact Info Locked</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
            Premium members can see {userName}'s contact details
          </p>
          <button
            onClick={onUnlockClick}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg transition"
          >
            🔓 Unlock with Premium
          </button>
        </div>
      );
    }

    // default variant
    return (
      <div className="bg-amber-50 dark:bg-amber-900/20 border-l-4 border-amber-400 p-4 rounded">
        <div className="flex items-start gap-3">
          <div className="text-2xl">🔒</div>
          <div className="flex-1">
            <h3 className="font-bold text-gray-800 dark:text-white">Contact Information Locked</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Upgrade to Premium to see {userName}'s phone number and contact details directly.
            </p>
            <button
              onClick={onUnlockClick}
              className="mt-3 inline-flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg transition"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
              Upgrade to Premium
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Premium user - show contact info
  const WhatsAppLink = () => (
    <a
      href={`https://wa.me/${phoneNumber}?text=Hi%20${encodeURIComponent(userName)}%2C%20I%20found%20your%20listing%20on%20Indian%20Flatmates!`}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg transition"
    >
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.67-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421-7.403h-.004a9.87 9.87 0 00-5.031 1.378c-3.055 2.169-3.92 6.519-1.91 9.833 2.01 3.314 6.407 4.21 9.616 2.412l.342-.195h3.023l-.641-3.297.339-.196c1.821-1.188 2.899-3.57 2.165-5.941-1.01-3.273-4.033-5.461-7.515-5.461" />
      </svg>
      WhatsApp
    </a>
  );

  const CallLink = () => (
    <a
      href={`tel:${phoneNumber}`}
      className="inline-flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-lg transition"
    >
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
      </svg>
      Call
    </a>
  );

  if (variant === "inline") {
    return (
      <div className="flex gap-2">
        <WhatsAppLink />
        <CallLink />
      </div>
    );
  }

  if (variant === "card") {
    return (
      <div className="bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 border-2 border-green-300 dark:border-green-700 rounded-lg p-4">
        <div className="text-center mb-4">
          <div className="inline-block bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 px-3 py-1 rounded-full text-xs font-bold mb-2">
            ⭐ Premium Member
          </div>
          <h3 className="font-bold text-gray-800 dark:text-white">Direct Contact</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">📱 {phoneNumber}</p>
        </div>
        <div className="flex gap-2">
          <WhatsAppLink />
          <CallLink />
        </div>
      </div>
    );
  }

  // default variant
  return (
    <div className="bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 p-4 rounded">
      <div className="flex items-start justify-between">
        <div>
          <div className="inline-block bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 px-2 py-1 rounded text-xs font-bold mb-2">
            ⭐ Premium
          </div>
          <h3 className="font-bold text-gray-800 dark:text-white">Contact Directly (Premium)</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">📱 {phoneNumber}</p>
        </div>
      </div>
      <div className="flex gap-2 mt-3">
        <WhatsAppLink />
        <CallLink />
      </div>
    </div>
  );
}
